import React from 'react';
import { Typography } from 'src/components';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPencil, faTrashCanXmark } from '@fortawesome/pro-solid-svg-icons';

interface EncountersItemProps {
  volume: {
    id: number;
    label: string;
    status?: string;
    volumeType: 'cohort';
  };
  isSelected: boolean;
  onSelect: () => void;
  onEdit: (e: React.MouseEvent) => void;
  onDelete: (e: React.MouseEvent) => void;
  onDragStart?: (e: React.DragEvent) => void;
  onDragEnd?: (e: React.DragEvent) => void;
}

const EncountersItem: React.FC<EncountersItemProps> = ({
  volume,
  isSelected,
  onSelect,
  onEdit,
  onDelete,
  onDragStart,
  onDragEnd,
}) => {
  const isProcessing = volume.status === 'PROCESSING';

  return (
    <div
      className="group px-6 py-1.5 hover:bg-neutral-100 cursor-pointer relative"
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      draggable={!!onDragStart}
    >
      <div className="flex items-center justify-between">
        <button
          type="button"
          className="flex flex-col items-start gap-1 flex-1 text-left"
          onClick={onSelect}
        >
          <Typography
            className={`text-sm ${
              isSelected
                ? 'text-sky-600 font-semibold'
                : 'text-text-primary font-semibold'
            }`}
          >
            {volume.label}
          </Typography>
          <div className="flex items-center gap-1">
            <Typography className="text-sm text-tertiary">
              Encounters
            </Typography>
            {isProcessing && (
              <span className="text-sm text-orange-500 italic ml-1">
                - In Progress
              </span>
            )}
          </div>
        </button>

        {/* Group icons in a flex container */}
        <div className="flex items-center gap-3">
          {/* Edit Icon - Shows on hover */}
          <button
            type="button"
            className="invisible group-hover:visible cursor-pointer"
            onClick={onEdit}
          >
            <Icon icon={faPencil} className="w-4 h-4 text-neutral-600" />
          </button>
          {/* Delete Icon - Shows on hover */}
          <button
            type="button"
            className="invisible group-hover:visible cursor-pointer"
            onClick={onDelete}
          >
            <Icon icon={faTrashCanXmark} className="w-4 h-4 text-neutral-600" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default EncountersItem;
